<template>
  <div id="pageRomaneios">
    <v-container grid-list-xs fluid>
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <div v-if="!paginatationDisabled">
        <v-card>
          <v-card-text>
            <v-form @submit.prevent="searchExplorer(1)">
              <v-layout row wrap>
                <v-flex md2 xs12>
                  <v-text-field
                    v-model="searchData.id"
                    label="Id"
                  ></v-text-field>
                </v-flex>
                <v-flex md3 xs12>
                  <v-text-field
                    v-model="searchData.name"
                    label="Nome"
                  ></v-text-field>
                </v-flex>
                <v-flex md2 xs12>
                  <v-text-field
                    v-model="searchData.document_number"
                    label="CPF"
                  ></v-text-field>
                </v-flex>
                <v-flex md2 xs12>
                  <v-autocomplete
                    v-model="searchData.property_id"
                    :items="properties"
                    :search-input.sync="search"
                    :loading="isLoading"
                    item-value="id"
                    item-text="name"
                    cache-items
                    clearable
                    hide-details
                    hide-no-data
                    hide-selected
                    label="Propriedade"
                  ></v-autocomplete>
                </v-flex>
                <v-flex md3 xs12>
                  <br />
                  <v-btn
                    @click="searchExplorer(1)"
                    small
                    class="ma-1"
                    color="primary"
                  >
                    <v-icon class="body-1">fa-search</v-icon> Buscar
                  </v-btn>
                  <v-btn
                    :to="{ name: 'ExplorerIndex' }"
                    small
                    class="ma-1"
                    color="gray"
                  >
                    Limpar
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
        <br />
        <v-card>
          <v-card-text>
            <v-data-table
              v-if="explorers.data"
              :headers="headers"
              :items="explorers.data"
              :mobile-breakpoint="960"
              disable-pagination
              hide-default-footer
              disable-sort
            >
              <template v-slot:top>
                <v-dialog v-model="dialogEdit" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Editar produtor</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field
                              v-model="editedItem.name"
                              label="Nome"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="editedItem.document_number"
                              label="CPF/CNPJ"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="editedItem.establishment_code"
                              label="Cod. estabelecimento"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="editedItem.ie"
                              label="IE"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="gray"
                        :disabled="loadingSave"
                        text
                        @click="dialogEdit = false"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        :loading="loadingSave"
                        text
                        @click="saveItem"
                        >Salvar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ item.created_at | formatDate }}
              </template>
              <template v-slot:item.document_number="{ item }">
                {{ item.document_number | formatCpfCnpj }}
              </template>
              <template v-slot:item.property.name="{ item }">
                <v-btn
                  class="indigo--text"
                  text
                  small
                  :to="{ name: 'Property', params: { id: item.property_id } }"
                >
                  {{ item.property.name }}
                </v-btn>
              </template>
              <template v-slot:item.edit="{ item }">
                <v-btn @click="editItem(item)" small icon color="primary"
                  ><v-icon size="20">fa-edit</v-icon></v-btn
                >
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <app-pagination
          v-if="explorers && explorers.pagination"
          :pagination="explorers.pagination"
          :disabled="paginatationDisabled"
          v-on:change-page="searchExplorer"
        ></app-pagination>
      </div>

      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import appApi from "../../plugins/api";
import AppPagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";
import moment from "moment";

export default {
  components: {
    "app-pagination": AppPagination,
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      search: null,
      isLoading: false,
      headers: [
        { text: "Id", value: "id", sortable: false },
        { text: "Nome", value: "name", sortable: false },
        { text: "CPF/CNPJ", value: "document_number", sortable: false },
        {
          text: "Cod. Estabelecimento",
          value: "establishment_code",
          sortable: false
        },
        { text: "Propriedade", value: "property.name", sortable: false },
        { text: "IE", value: "ie", sortable: false },
        { text: "Data Cadastro", value: "created_at", sortable: false },
        { text: "Editar", value: "edit", sortable: false }
      ],
      explorers: {},
      currentPage: 1,
      paginatationDisabled: false,
      dialog: false,
      snackbarCsv: false,
      updateIdx: null,
      deleteMessage: "",
      modalType: null,
      snackbar: {},
      searchData: {},
      properties: [],
      formatDates: {
        intlDate: "YYYY-MM-DD",
        ini: {
          date: "",
          modalDateInit: false
        },
        end: {
          date: "",
          modalDateInit: false
        }
      },
      loadingSave: false,
      dialogEdit: false,
      editedIndex: null,
      editedItem: {
        name: "",
        document_number: "",
        establishment_code: 0,
        ie: 0
      }
    };
  },

  computed: {},
  watch: {
    search(val) {
      this.isLoading = true;
      appApi.getProperties({ name: val, per_page: 5 }).then(result => {
        this.properties = result.data.data;
      });
      this.isLoading = false;
    }
  },

  mounted: function() {
    window.scrollTo(0, 0);

    if (this.$route.query.page) {
      this.searchData["page"] = this.$route.query.page;
    } else {
      this.searchData["page"] = 1;
    }

    if (this.$route.query.id) {
      this.searchData["id"] = this.$route.query.id;
    }
    if (this.$route.query.document_number) {
      this.searchData["document_number"] = this.$route.query.document_number;
    }
    if (this.$route.query.name) {
      this.searchData["name"] = this.$route.query.name;
    }
    if (this.$route.query.property_id) {
      this.searchData["property_id"] = this.$route.query.property_id;
      appApi.getProperty(this.$route.query.property_id).then(response => {
        this.properties = [response.data];
      });
    }

    this.getExplorers(this.searchData);
  },

  methods: {
    searchExplorer: function(page) {
      let data = { page: page ? page : 1 };

      if (this.searchData.id) {
        data["id"] = this.searchData.id;
      }
      if (this.searchData.document_number) {
        data["document_number"] = this.searchData.document_number.replace(
          /\D/g,
          ""
        );
      }
      if (this.searchData.name) {
        data["name"] = this.searchData.name;
      }
      if (this.searchData.property_id) {
        data["property_id"] = this.searchData.property_id;
      }
      this.$router.push({ name: "ExplorerIndex", query: data });
    },

    getExplorers: function(data) {
      this.paginatationDisabled = true;

      this.explorers.data = [];
      appApi
        .getExplorers(data)
        .then(result => {
          this.explorers = result.data;
          console.log(this.explorers)
          this.paginatationDisabled = false;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    editItem(item) {
      this.editedIndex = this.explorers.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEdit = true;
    },

    saveItem() {
      this.loadingSave = true;
      appApi
        .putExplorer(this.editedItem.id, this.editedItem)
        .then(result => {
          this.loadingSave = false;
          Object.assign(this.explorers.data[this.editedIndex], result.data);
          this.snackbar = {
            show: true,
            text: "Salvo com sucesso!",
            color: "success"
          };
        })
        .catch(err => {
          this.loadingSave = false;
          this.snackbar = {
            show: true,
            text: "Erro ao salvar",
            color: "error"
          };
        });
    }
  }
};
</script>
<style scoped lang="css">
>>> .v-data-table-header.v-data-table-header-mobile {
  display: none;
}
</style>
